import { OfflineError } from "./api.ts";

/** What a read says of the server: whether it holds data, and why its last try failed. */
export interface ReadState {
  data: unknown;
  fetchFailureReason: unknown;
}

/**
 * Whether a screen is empty for want of a server: some read on it has
 * nothing to show and its last try could not reach the server. Every page
 * stayed blank on the phone when that happened, with nothing to say why
 * (14/10). A read that already holds data keeps showing it; a refusal from
 * the server is that screen's own error, not this.
 */
export function serverUnreachable(reads: readonly ReadState[]): boolean {
  return reads.some((read) => read.data === undefined && read.fetchFailureReason instanceof OfflineError);
}
